import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';

import config from 'config';
import {inviteMember as inviteMemberApi} from 'services/company/api';
import {handleValueChange} from 'utils/ComponentUtilFunctions';
import Translate from 'components/Translate';
import TranslateProperty from 'components/TranslateProperty';
import CustomInput from 'components/input-text';
import CustomSelect from 'components/select';
import BlueButton from "../../../../../components-new/buttons/BlueButton";

const styles = {
    roleSelectInput: {
        overflow: 'visible',
    },
    inputFieldWrapper: {
        display: 'flex',
        height: '50px',
        width: '420px',
        position: 'relative',
    },
    title: {
        fontSize: '16px',
        marginBottom: '20px',
    },
};

class InviteMember extends React.Component {
    constructor(props) {
        super(props);
        const {roles} = config;
        this.state = {
            role: roles[0] ? roles[0].value : '',
            email: '',
            inviting: false,
        };
        this.handleChange = handleValueChange.bind(this);
    }


    componentDidMount() {
        const {role} = this.state;
        const {roles} = config;

        if (!role && roles[0]) {
            this.setState({
                role: roles[0].value,
            });
        }
    }

    getApiDataFromState() {
        const {role, email} = this.state;
        const subCompanyIds = [];
        return {
            role,
            email,
            subCompanyIds,
        };
    }

    invite = () => {
        const {inviting} = this.state;

        if (inviting) {
            return;
        }

        const {addNotification} = this.props;


        this.setState({
            inviting: true,
        });

        inviteMemberApi(
            this.getApiDataFromState()
        ).then(() => {
            addNotification('memberInvited');
            this.props.fetchCompany();
        }).catch((e) => {
            if (e.toString().includes("403")) {
                addNotification('operatorLimitExceeded', config.notificationLevels.error);
            } else if (e.toString().includes("406")) {
                addNotification('invalidEmail', config.notificationLevels.error);
            } else if (e.toString().includes("409")) {
                addNotification('userEmailExists', config.notificationLevels.error);
            } else {
                addNotification('somethingWentWrong', config.notificationLevels.error);
            }
        }).finally(() => {
            this.setState({
                inviting: false,
            });
        });
    };

    render = () => {
        const {
            classes, commonStyles,
        } = this.props;
        const {
            email, role, inviting,
        } = this.state;

        let roles = config.roles.filter((c) => c.id !== config.rolesMap.owner);

        if (!role && roles[0]) {
            this.setState({
                role: roles[0].value,
            });
        }


        const {user} = this.props;


        if (user.authorities[0] === config.rolesMap.admin) {
            roles = roles.filter(it => it.name !== 'OWNER')
        }


        return (
            <div>
                <div style={{display: 'flex', gap: '15px'}}>
                    <div className={classes.inputFieldWrapper}>
                        <TranslateProperty properties={[{key: 'placeholder', value: 'enterEmailHere'}]}>
                            <CustomInput controlled handleChange={this.handleChange('email')} value={email}
                                         inputStyles={{width: '420px', height: '50px', paddingRight: '100px'}}/>
                        </TranslateProperty>
                        <div className="centered-flex-container"
                             style={{position: 'absolute', right: 1, height: '50px'}}>
                            <CustomSelect
                                options={roles}
                                selected={role}
                                height={40}
                                itemHoverColor="#F04D4D"
                                handleSelect={this.handleChange('role')}
                                title="role"
                                wrapperStyles={{boxShadow: 'none', width: '85px'}}
                                listStyles={{boxShadow: 'none'}}
                            />
                        </div>
                    </div>
                    <div>
                        <BlueButton type={'button'}
                                    width={'120px'}
                                    disabled={inviting}
                                    children={<Translate text="invite"/>}
                                    onClick={this.invite}/>
                    </div>
                </div>
            </div>
        );
    };
}

InviteMember.propTypes = {
    addNotification: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    commonStyles: PropTypes.shape({
        smallTitle: PropTypes.object.isRequired,
    }).isRequired,
    user: PropTypes.object.isRequired,
    fetchCompany: PropTypes.func.isRequired
};


export default withStyles(styles)(InviteMember);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/InviteMember.jsx